//* 모바일은 헤더 아래에 상시 붙어 화면을 먹으므로 허용 목록으로 좁히고, PC는 헤더 안 인라인이라 제휴·별도 상품만 뺀다.
//* 목록·메인만 여는 경로 — 하위는 이벤트 화면(행운권·출석체크)이거나 전면 이미지 상세라 스티키 바가 가린다.
const MOBILE_ALLOWED_PATHS = ['/', '/benefit', '/festival'];

const MOBILE_ALLOWED_PATH_PREFIXES = [
  '/search',
  '/policy',
  '/article',
  '/community',
];

const DESKTOP_EXCLUDED_PATH_PREFIXES = [
  '/donation',
  '/welmarket',
  '/kakaobank',
  '/kb-home',
  '/voucher',
];

const matchesPrefix = (pathname: string, prefixes: string[]) =>
  prefixes.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );

export const shouldShowMobileTrendKeyword = (pathname: string) =>
  MOBILE_ALLOWED_PATHS.includes(pathname) ||
  matchesPrefix(pathname, MOBILE_ALLOWED_PATH_PREFIXES);

export const shouldShowDesktopTrendKeyword = (pathname: string) =>
  !matchesPrefix(pathname, DESKTOP_EXCLUDED_PATH_PREFIXES);

// 트랙 트랜지션과 되감기 타이머가 같은 값을 봐야 해서 여기 한 곳에 둔다.
export const ROLLING_DURATION_MS = 500;

//* 시안(`11610-27049`)의 「1~10위 / 11~20위」 이동 버튼 — 페이지당 행 수이자 상위 강조 경계다.
export const TREND_PAGE_SIZE = 10;

//* 상위 5위는 순위 숫자를 강조색으로 쓴다(시안 PC 패널).
export const TREND_TOP_RANKING_MAX = 5;
